import React, { useEffect, useRef } from "react";
import cloudinary from "cloudinary-video-player";

export const VideoPlayer = (props) => {
  const { 
    id,
    autoplay, 
    controlColour, 
    controls, 
    loop, 
    muted, 
    poster, 
    publicId, 
    } = props;

  const bool = (v) => v === 'True' || v === true;
  const playerInstanceRef = useRef();
  const playerRef = useRef();
  const isAutoplay = bool(autoplay);

  useEffect(() => {
    if (playerInstanceRef.current) return;

    playerInstanceRef.current = cloudinary;

    const options = {
      cloudName: "asos-prod",
      secureDistribution: "www.asos-video.com",
      privateCdn: true,
      chapters: true,
      controls: bool(controls),
      autoplay: isAutoplay,
      playsinline: isAutoplay,
      muted: isAutoplay ? true : bool(muted),
      loop: bool(loop),
      colors: {
        accent: controlColour,
        text: controlColour,
      },
      showJumpControls: true,
      hideContextMenu: true,
      showLogo: false,
      posterOptions: {
        publicId: poster,
      },
      transformation: isAutoplay ? [] : [{ effect: ["volume:auto"] }],
      sourceTypes: ["hls"],
    }

    const player = playerInstanceRef.current.videoPlayer(playerRef.current, options);

    if (publicId) {
      player.source(publicId);
    }

    const checkAndPlay = () => {
      const videoEl = playerRef.current
      if (videoEl && videoEl.paused) {
        videoEl.muted = true;
        videoEl.setAttribute('muted', '');
        videoEl.setAttribute('playsinline', '');
        const playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.warn("Autoplay failed:", error);
          });
        }
      }
    };
    
    if (isAutoplay) {
      player.on('loadedmetadata', checkAndPlay);
      const timeoutId = setTimeout(checkAndPlay, 500);
      playerInstanceRef.current._autoplayTimeout = timeoutId;
    }

    return () => {
      if (player && typeof player.destroy === "function") {
        try {
          player.off && player.off('loadedmetadata', checkAndPlay);
        } catch (e) { /* ignore */ }
        if (playerInstanceRef.current && playerInstanceRef.current._autoplayTimeout) {
          clearTimeout(playerInstanceRef.current._autoplayTimeout);
        }
        if (typeof player.destroy === "function") {
          player.destroy();
        }      
      }
    };
  }, []);

  return (
    <video
      ref={playerRef}
      id={id}
      className="cld-video-player cld-fluid"
    />
  );
};
